import moment from "moment";
export const getProfileRole = (details) => {
  const result = "";
  if (details.designation && details.company_name) {
    result = details.designation + ", " + details.company_name;
  } else if (details.degree && details.field_of_study) {
    result = details.degree + ", " + details.field_of_study;
  }

  return result;
};

export const debounceMethod = (func) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), 300);
  };
};

/**
 * Formats a file form input.files to base 64.
 *
 * @param   {File} file    File form input.files
 * @returns {Promise}
 */
export function getFileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

export default async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}

export const checkSessionTimeStatus = ({
  duration,
  startDateTime,
  timeType = "minutes",
}) => {
  const sessionStartTime = moment(startDateTime);
  const sessionEndTime = moment(startDateTime).add(duration, timeType);

  const currentDateTime = moment();
  if (sessionStartTime.diff(currentDateTime, "minutes") > 15) {
    return "FUTURE";
  } else if (
    sessionStartTime.diff(currentDateTime, "minutes") <= 15 &&
    sessionEndTime.diff(currentDateTime, "minutes") >= 0
  ) {
    return "PRESENT";
  } else {
    return "PAST";
  }
};

export const checkTrainingTimeStatus = ({ endDateTime, startDateTime }) => {
  const sessionStartTime = moment(startDateTime).utcOffset("+05:30");
  const sessionEndTime = moment(endDateTime).utcOffset("+05:30");

  const currentDateTime = moment().utcOffset("+05:30");

  if (sessionStartTime.diff(currentDateTime, "minutes") > 0) {
    return "UPCOMING";
  } else if (
    sessionStartTime.diff(currentDateTime, "minutes") <= 0 &&
    sessionEndTime.diff(currentDateTime, "minutes") >= 0
  ) {
    return "ONGOING";
  } else {
    return "COMPLETED";
  }
};

export const checkSessionTabStatus = ({
  duration,
  startDateTime,
  timeType = "minutes",
}) => {
  const sessionStartTime = moment(startDateTime);
  const sessionEndTime = moment(startDateTime).add(duration, timeType);

  const currentDateTime = moment();

  if (sessionEndTime.diff(currentDateTime, "minutes") < 0) {
    return "PAST";
  } else {
    return "UPCOMING";
  }
};


export function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}


export const progressBarColor = (percent) => {
  if (percent <= 60) {
    return "#F68C50";
  } else if (60 < percent && percent < 90) {
    return "#67BD4A";
  } else if (90 <= percent) {
    return "#67BD4A";
  }
};




export const statusList = [
  { filter_name: "All Status" },
  { filter_name: "Attempted" },
  { filter_name: "Not attempted" },
  { filter_name: "In progress" },
  { filter_name: "Expired" },
];

export const filterByCategory = ({ selectedFilter, backupData, filters }) => {
  const filterName = selectedFilter.toLowerCase();

  const keysList = Object.keys(backupData).map((key) => key);

  let currentObj = {};

  if (filterName === "All Assessments".toLowerCase()) {
    keysList.forEach((currentKey) => {
      currentObj[currentKey] = backupData[[currentKey]]?.filter((el) =>
        el.testname ? true : false
      );
    });
  } else {
    const subFilters = filters.find(({ filter_name }) => {
      return filter_name.toLowerCase() === filterName.toLowerCase();
    })?.subfilter_data;
    let subFilterNames = subFilters
      ? subFilters.map((a) => a.subfilter_name)
      : [];

    subFilterNames = [...subFilterNames, selectedFilter];

    keysList.forEach((currentKey) => {
      currentObj[currentKey] = backupData[[currentKey]]?.filter(
        (currentAssesment) => {
          return subFilterNames.some((currentKeyword) =>
            currentAssesment.testname.includes(currentKeyword)
          )
            ? true
            : false;
        }
      );
    });
  }
  return currentObj;
};

export const filterByStatus = ({ selectedFilter, setData, backupData }) => {
  const keysList = Object.keys(backupData).map((key) => key);

  let currentObj = {};

  switch (selectedFilter) {
    case "All Status":
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => !!el.testname
        );
      });

      setData(currentObj);

      return;

    case "Attempted":
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => el.is_attempted && el.test_status != "in progress"
        );
      });

      setData(currentObj);

      return;

    case "Not attempted":
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => el.is_attempted === false
        );
      });

      setData(currentObj);
      return;

    case "In progress":
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => el.test_status === "in progress"
        );
      });

      setData(currentObj);
      return;
    case "Expired":
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => moment().diff(el.expiry_date, "minutes") > 0
        );
      });

      setData(currentObj);
      return;
    default:
      keysList.forEach((currentKey) => {
        currentObj[currentKey] = backupData[[currentKey]]?.filter(
          (el) => !!el.testname
        );
      });

      setData(currentObj);
      return null;
  }
};

export const filterAssesment = ({ fltrObj, setData, backupData, filters }) => {
  const latestData = filterByCategory({
    selectedFilter: fltrObj.categories,
    backupData,
    filters,
  });

  filterByStatus({
    selectedFilter: fltrObj.status,
    setData,
    backupData: latestData,
  });
};
export const searchByName = ({ searchText, setData, backupData }) => {
  const keysList = Object.keys(backupData).map((key) => key);

  let currentObj = {};
  keysList.forEach((currentKey) => {
    currentObj[currentKey] = backupData[[currentKey]]?.filter((el) =>
      el.testname?.toLowerCase()?.includes(searchText?.toLowerCase())
    );
  });

  setData(currentObj);
};
export const getTime =({time,format})=>{

  let currentTimeUTC = moment(time).utc();

  return moment(currentTimeUTC).utcOffset("+05:30").format(format)

}
